module.exports = __webpack_public_path__ + "v4assets/explorer-screenshot.6853e875b0498b688780825c07fddcd7.png";